import React, { useRef } from 'react'
import { Button } from '../../../../ui/Button'
import { Spinner } from '../../../../ui/Spinner'
import { InfoAlert } from './InfoAlert'

interface CalendlyWidgetProps {
  isLoading: boolean
  calendlyUrl: string
  onBack: () => void
}

export const CalendlyWidget: React.FC<CalendlyWidgetProps> = ({
  isLoading,
  calendlyUrl,
  onBack,
}) => {
  const calendlyRef = useRef<HTMLDivElement>(null)

  return (
    <div className="max-w-4xl mx-auto">
      {/* Header with back button */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <button
            onClick={onBack}
            className="mr-4 p-2 rounded-full hover:bg-gray-100 transition-colors"
            disabled={isLoading}
          >
            <svg
              className="w-6 h-6 text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <div>
            <h1 className="text-xl font-bold text-gray-900">
              Selecciona tu horario preferido
            </h1>
            <p className="text-sm text-gray-600">
              Elige la fecha y hora que mejor te convenga
            </p>
          </div>
        </div>
      </div>

      {/* Calendly Widget */}
      <div className="bg-red-100 rounded-lg shadow-sm border overflow-hidden relative">
        <div
          ref={calendlyRef}
          className="min-h-[600px] w-full"
          style={{ minHeight: '600px' }}
        />
        {isLoading && (
          <div className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center">
            <div className="flex items-center">
              <Spinner size="lg" />
              <span className="ml-3 text-gray-600">Cargando calendario...</span>
            </div>
          </div>
        )}

        {/* Fallback: Button to open in new window */}
        <div className="absolute top-4 right-4">
          <Button
            onClick={() => window.open(calendlyUrl, '_blank')}
            variant="outline"
            size="sm"
          >
            <svg
              className="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
            Abrir en nueva ventana
          </Button>
        </div>
      </div>

      <InfoAlert
        title="Información importante"
        description="Una vez que completes el agendamiento, automáticamente procederemos al siguiente paso del proceso."
      />
    </div>
  )
}
